/*
 * @Date: 2022-08-16 09:31:08
 * @LastEditTime: 2023-03-15 09:15:29
 */
import { useUserStore } from "@/store/index";

// 刷新页面后设置缓存
const Initializer = () => {
  const userStore = useUserStore();

  // 从localStorage恢复用户状态并初始化关联数据
  userStore.initUserState();
};

// 设置为不输出日志（上线使用）
const rewirteLog = () => {
  console.log = (function (log) {
    return process.env.NODE_ENV === "production" ? function () {} : log;
  })(console.log);
};

export { Initializer, rewirteLog };
